// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P7Yzr","controls":"styles_controls__123b2","charLimit":"styles_charLimit__Ixk-r","input":"styles_input__2WFuF","send":"styles_send__j-vL3"};